var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { UserPermissionEvaluator } from './UserPermissionEvaluator';
import { runtime } from '../../runtime/Runtime';
import { APIData } from '../../api/APIData';
export class UserPermission {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get user() {
        return this.parent;
    }
    get app() {
        return this.user.app;
    }
    get userPermissionsQuery() {
        return new APIData({
            route: '/api/user/permissions',
            defaultValue: [],
        });
    }
    get permissionRules() {
        return this.userPermissionsQuery.streamedRef;
    }
    get permissionEvaluators() {
        return this.permissionRules.map(rule => new UserPermissionEvaluator(this, rule));
    }
    get hasEditPermissionsForCurrentLocation() {
        if (runtime.isBot)
            return true;
        return this.permissionEvaluators.map(e => e.hasEditPermissionsForCurrentLocation).includes(true);
    }
    get hasAdminPermissionsForCurrentLocation() {
        return this.permissionEvaluators.map(e => e.hasAdminPermissionsForCurrentLocation).includes(true);
    }
    get shouldSaveEditEntities() {
        if (!runtime.availablePackages.Edit)
            return false;
        return this.hasEditPermissionsForCurrentLocation;
    }
}
__decorate([
    memoize
], UserPermission.prototype, "userPermissionsQuery", null);
__decorate([
    computed // checked!!
], UserPermission.prototype, "hasAdminPermissionsForCurrentLocation", null);
